import { render, staticRenderFns } from "./PageMn.vue?vue&type=template&id=21bc1c64&"
import script from "./PageMn.vue?vue&type=script&lang=js&"
export * from "./PageMn.vue?vue&type=script&lang=js&"
import style0 from "./PageMn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports